<template>
	<div>
		<div class="container">
		<div class="row">
				<div class="col-12 biz-title-container">
					<div class="container">
						<div class="biz-panel-title">
							<h3>Moji komentari</h3>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12 salon-container mb-3">
					<div class="container mb-3">
						<div class="row no-gutters">
							<div v-for="(comment,index) in comments" :key="index" class="col-12">
									<div class="row no-gutters">
										<div class="col-12 komentar-header">
											<div class="komentar-header-left">
												<h4 class="komentar-username">{{comment.salon.name}}</h4>
												<div class="mt-1">
													<span :class="comment.rating >= 1 ? 'fa fa-star checked':'fa fa-star'"></span>
													<span :class="comment.rating >= 2 ? 'fa fa-star checked':'fa fa-star'"></span>
													<span :class="comment.rating >= 3 ? 'fa fa-star checked':'fa fa-star'"></span>
													<span :class="comment.rating >= 4  ? 'fa fa-star checked':'fa fa-star'"></span>
													<span :class="comment.rating == 5 ? 'fa fa-star checked':'fa fa-star'"></span>
												</div>
											</div>
											<div class="komentar-header-right">
												<small class="komentar-date">{{format_croatia_date(new Date(comment.created_at).toDateString())}}</small>
											</div>
										</div>
										<div class="col-12 komentar-body">
											<p v-if="!comment.edit" class="komentar-tekst">{{comment.text}}</p>
											<p v-if="comment.edit" class="komentar-tekst">
												<textarea class="form-control" id="" cols="30" rows="5" v-model="comment.text"></textarea>
											</p>
										</div>
									</div>
									<div v-for="(response,index) in comment.response" :key="index" class="col-12 komentar-div response">
										<div class="row no-gutters">
											<div class="col-12 komentar-header">
												<div class="komentar-header-left">
													<h4 class="komentar-username">Odgovor</h4>
												</div>
												<div class="komentar-header-right">
													<small class="komentar-date">{{new Date(response.created_at).toDateString()}}</small>
												</div>
											</div>
											<div class="col-12 komentar-body">
												<p class="komentar-tekst">{{response.text}}</p>
											</div>
										</div>
									</div>
									<hr>
								</div>
							<div class="col-12" v-if="loadingComment">
								<loader color='red'></loader>
							</div>
							<div v-if="last_page > 1" class="col-12">
								<nav aria-label="Page navigation">
									<ul class="pagination justify-content-center">
										<li class="page-item align-self-center">
											<a @click="loadComment(comment_current_page <=0 ? 0:comment_current_page - 1)" class="page-link" aria-label="Previous">
												<span aria-hidden="true">&laquo;</span>
												<span class="sr-only">Previous</span>
											</a>
										</li>
										<li v-for="(page,index) in pagination" :key="index" :class="page == comment_current_page ? 'page-item active':'page-item '"><a class="page-link" @click="loadComment(page)">{{page}}</a></li>
										<li class="page-item">
											<a @click="loadComment(comment_current_page >= last_page ? last_page:comment_current_page + 1)" class="page-link" aria-label="Next">
												<span aria-hidden="true">&raquo;</span>
												<span class="sr-only">Next</span>
											</a>
										</li>
									</ul>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		mapState
	} from 'vuex';
		import {
		module_mixin
	} from '../../../mixins/index';
	export default {
		mixins: [module_mixin],
		computed: {
			...mapState({
				user: (state) => state.user,
				loader: (state) => state.loader,
				token: (state) => state.token,
				endpoint: (state) => state.endpoint,
				head: (state) => state.booking_head,
				body: (state) => state.booking_body,
			})
		},
		data() {
			return {
				loadingComment: false,
				comment_current_page: 1,
				last_page: 0,
				comments: [],
				pagination: [],
			}
		},
		methods: {
			saveComment(id) {
				var comment = {};
				this.comments = this.comments.map((d) => {
					if (d.id == id) {
						d.edit = false;
						comment = d;
					}
					return d;
				});

				this.$store.dispatch('post', {
						endpoint: this.endpoint + 'update-user-comment/' + id + '?token=' + this.token,
						details: comment
					})
					.then((data) => {
						console.log(data);
					});
			},
			// delComment(id){ 
			//     if(!confirm("Are you sure you want to delete this item?")){
			//         return false;
			//     }
			//     this.comments=this.comments.filter((d)=> d.id !=id);

			//     this.$store.dispatch('get',this.endpoint+'update-user-comment/'+id+'?token='+this.token)
			//     .then((data)=>{
			//         console.log(data);
			//     });
			// },
			// editComment(id){
			//     this.comments=this.comments.map((d)=>{
			//         if(d.id == id){
			//             d.edit=true;
			//         }
			//         return d;
			//     });
			// },
			loadComment(page) {
				this.loadingComment = true;
				this.$store.state.loader = true;
				this.$store.dispatch('get', this.endpoint + 'get-user-comments/' + this.user.id + '?page=' + page + '&token=' + this.token)
					.then((data) => {
						console.log(data.data);
						this.comments = data.data.data;
						this.comment_current_page = data.data.current_page;
						this.last_page = data.data.last_page;
						this.pagination = [];
						for (var c = 1; c <= data.data.last_page; c++) {
							this.pagination.push(c);
						}
						this.loadingComment = false;
					})
					.catch((error) => {
						console.log(error.request);
						this.loadingComment = false
					});

			},
			formatDate(date) {
				return date.split('-').map((d) => {
					if (d.length < 4) {
						if (d.length < 2) {
							d = '0' + d.toString();
						}
					}
					return d;
				}).join('-');
			}
		},
		created() {
			this.loadComment(1);
		}
	}

</script>
<style scoped>
	.response {
		background: #d3d3d330;
		width: 80%;
		margin-left: auto;
		margin-top: 20px;
	}

</style>
